/**
 * Directive: posPage
 */
angular.module('acme.common.directive.posPage', [
  'ui.sortable',
  'angularUUID2',
  'acme.common.service.posConfig',
  'acme.common.directive.posTile',
  'acme.common.directive.posNavigator'
])
.directive('posPage', [ '$timeout', 'PosConfigService', 'uuid2', function($timeout, PosConfigService, uuid2){

  return {
    restrict: 'A',
    templateUrl: 'common/directives/pos/page/page.tpl.html',
    scope: {
      minRows: '@',
      maxRows: '@',
      minColumns: '@',
      maxColumns: '@',
      showTopNavigator: '@',
      rows: '=',
      columns: '=',
      page: '=',
      pages: '=',
      validate: '='
    },

    link: function($scope, $element, $attrs) {},

    controller: ['$scope', function($scope) {

      $scope.posPage = {

        tiles: [],

        rows: {
          min: 5,
          max: 30,
          total: 5
        },

        columns: {
          min: 4,
          max: 4,
          total: 4
        },

        init: function() {

          $scope.$watch('page', function (val) {
            console.log(val);
            //if(Object.keys(val).length > 0) {
            //  $scope.posPage.reset();
            //}
            $scope.posPage.reset();

          });

          $scope.$on('PosTile::Select', this.onPosTileSelect);
          $scope.$on('PosTile::Remove', this.onPosTileRemove);
          $scope.$on('PosTile::Move', this.onPosTileMove);
          $scope.$on('PosTile::Swap', this.onPosTileSwap);

        },

        reset: function() {


          if (!isNaN(parseInt($scope.rows, 10))) {
            this.rows.total = parseInt($scope.rows, 10);
          }

          if (!isNaN(parseInt($scope.maxRows, 10))) {
            this.rows.max = parseInt($scope.maxRows, 10);
          }

          if (!isNaN(parseInt($scope.minRows, 10))) {
            this.rows.min = parseInt($scope.minRows, 10);
          }

          if (!isNaN(parseInt($scope.columns, 10))) {
            this.columns.total = parseInt($scope.columns, 10);
          }

          if (!isNaN(parseInt($scope.minColumns, 10))) {
            this.columns.min = parseInt($scope.minColumns, 10);
          }

          if (!isNaN(parseInt($scope.maxColumns, 10))) {
            this.columns.max = parseInt($scope.maxColumns, 10);
          }

          if (this.rows.total < this.rows.min) {
            this.rows.total = this.rows.min;
          }else if (this.rows.total > this.rows.max) {
            this.rows.total = this.rows.max;
          }

          if (this.columns.total < this.columns.min) {
            this.columns.total = this.columns.min;
          }else if (this.columns.total > this.columns.max) {
            this.columns.total = this.columns.max;
          }

          this.generateTiles();
        },

        hasTiles: function() {
          return ($scope.page.items instanceof Array && $scope.page.items.length);
        },

        generateTiles: function() {
          var x,
              y,
              k,
              i, ii,
              row = 0,
              column = 0,
              index = 0,
              tileIndex = 0,
              tiles = [],
              last = -1,
              lastTile;

          for (y = 0; y < this.rows.total; y++) {
            for (x = 0; x < this.columns.total; x++) {
              tiles.push(PosConfigService.tiles.emptyTile(x, y));
            }
          }

          if (this.hasTiles()) {
            for (k = 0; k < $scope.page.items.length; k++) {
              row = $scope.page.items[k].config.y;
              column = $scope.page.items[k].config.x;
              tileIndex = row * this.columns.total;

              $scope.page.items[k].config.id = uuid2.newuuid();

              if (this.rows.total <= row) {
                for (i = 0, ii = row - this.rows.total + 2; i < ii; i++) {
                  tiles = tiles.concat(this.createRow());
                  this.rows.total++;
                }
              }

              index = column + tileIndex;
              tiles[index] = $scope.page.items[k];
              tiles[index].isEmpty = false;
            }
          }

          this.tiles = tiles;
          this.updateRows();

          // get the position of the last tile placed in the last row
          for (i=0,ii=this.tiles.length;i<ii;i++) {
            if (!this.tiles[i].isEmpty) {
              if (last < this.tiles[i].config.y + 1) {
                last = this.tiles[i].config.y + 1;
                lastTile = this.tiles[i];
              }
            }
          }

          if (lastTile) {
            this.onPosTileSelect({}, lastTile);
          }

        },

        createRow: function() {

          var x,
              ii,
              tiles = [];


          for (x=0,ii=this.columns.total;x<ii;x++) {
            tiles.push(PosConfigService.tiles.emptyTile(x, this.rows.total));
          }

          return tiles;

        },

        updateRows: function() {
          this.rows.total = this.tiles.length / parseInt(this.columns.total, 10);
          PosConfigService.tiles.setModel(this.tiles);
        },

        checkRow: function(index) {
          return (index % this.columns.total === 0);
        },

        removeRow: function(rowStartIndex, rowLength) {
          this.tiles.splice(rowStartIndex, rowLength);
        },

        moveTile: function(sourceId, targetId) {
          var tmpTile,
              position,
              self = $scope.posPage,
              sourceFound = PosConfigService.tiles.findTile(sourceId),
              targetFound = PosConfigService.tiles.findTile(targetId),
              sourceTile = (sourceFound) ? angular.copy(sourceFound.tile) : false,
              targetTile = (targetFound) ? angular.copy(targetFound.tile) : false;

          if (targetTile && sourceTile) {
            // Swap configurations between source tile and target tile
            tmpTile = angular.copy(targetTile);

            // Move source tile position to target tile position and store source tile position
            position = PosConfigService.tiles.getPosition(targetTile.config.x, targetTile.config.y);

            targetTile.config.x = sourceTile.config.x;
            targetTile.config.y = sourceTile.config.y;
            targetTile.x = targetTile.config.x;
            targetTile.y = targetTile.config.y;

            // Move target tile position to source tile position
            position = PosConfigService.tiles.getPosition(tmpTile.config.x, tmpTile.config.y);

            sourceTile.config.x = tmpTile.config.x;
            sourceTile.config.y = tmpTile.config.y;
            sourceTile.x = tmpTile.config.x;
            sourceTile.y = tmpTile.config.y;

            // Only for navigation tiles
            if (sourceTile.config.pageId) {
              targetTile.config.pageId = sourceTile.config.pageId;
              sourceTile.config.pageId = null;
              delete sourceTile.config.pageId;
            }

            // Reassign tiles
            this.tiles[targetFound.index] = sourceTile;
            this.tiles[sourceFound.index] = targetTile;

            // next tick
            $timeout(function () {
              self.updateRows();
            }, 0);


            // Add rows
            $timeout(function () {
              self.onPosTileSelect({}, self.tiles[sourceFound.index]);
            }, 1);

            // next tick
            $timeout(function () {
              self.updateRows();
            }, 2);

            // Remove rows
            $timeout(function () {
              self.onPosTileRemove();
            }, 3);

            $scope.page.items = PosConfigService.tiles.process(this.tiles);
          }

        },

        swapTile: function(sourceId, targetId) {
          // passthru function
          this.moveTile(sourceId, targetId);
        },

        onPosTileSelect: function(e, data) {

          var self = $scope.posPage;

          if (self.rows.total < self.rows.max &&
              data.config.y === self.rows.total - 1) {
            self.tiles = self.tiles.concat(self.createRow());
            self.rows.total++;
          }

          PosConfigService.tiles.setModel(self.tiles);

        },

        onPosTileRemove: function(e, data) {

          var i, ii,
              rowStartIndex,
              self = $scope.posPage,
              last = self.rows.min - 1;

          // Start from minimum number of rows and truncate empty rows - 1 thereafter
          for (i=0,ii=self.tiles.length;i<ii;i++) {
            if (!self.tiles[i].isEmpty) {
              if (last < self.tiles[i].config.y + 1) {
                last = self.tiles[i].config.y + 1;
              }
            }
          }

          for (i=self.rows.total,ii=last;i>ii;i--) {
            rowStartIndex = parseInt(i, 10) * parseInt(self.columns.total, 10);
            self.removeRow(rowStartIndex, self.columns.total);
          }

          self.updateRows();

        },

        onPosTileMove: function(e, data) {
          $scope.posPage.moveTile(data.target, data.source);
        },

        onPosTileSwap: function(e, data) {
          $scope.posPage.swapTile(data.target, data.source);
        }

      };

      $scope.posPage.init();

    }]

  };

}]);
